/**
 * Pure logic for the cleanup actions that should run when Escape closes the
 * ScreenShareModal.  Extracted so it can be unit-tested without jsdom.
 */

export interface EscapeCleanupState {
  /** Whether the UI button still reports screen-sharing as active. */
  screenShareEnabled: boolean
  /** Whether the modal is displaying the local user's own share. */
  isLocalSharing: boolean
  /** Filtered participant list from LiveKit (virtual-room scoped). */
  participants: ReadonlyArray<{ identity: string; isScreenShareEnabled: boolean }>
  /** The participant / track the modal is currently showing. */
  maximizedScreenShare: { participantId: string }
  /** Non-null when the presenter has an unanswered takeover request. */
  incomingTakeoverRequest: unknown
  /** Colyseus room handle (non-null when connected). */
  room: unknown
}

export interface EscapeCleanupActions {
  /** Send a "declined" takeover response so the requester isn't stuck. */
  declineTakeoverRequest: boolean
  /** Dispatch LIVEKIT_SCREEN_SHARE_STATE_CHANGED to resync the button. */
  resetScreenShareButton: boolean
}

export function getEscapeCleanupActions(state: EscapeCleanupState): EscapeCleanupActions {
  const declineTakeoverRequest = !!(state.incomingTakeoverRequest && state.room)

  let resetScreenShareButton = false
  if (state.screenShareEnabled && state.isLocalSharing) {
    const participant = state.participants.find(
      (p) => p.identity === state.maximizedScreenShare.participantId,
    )
    if (participant && !participant.isScreenShareEnabled) {
      resetScreenShareButton = true
    }
  }

  return { declineTakeoverRequest, resetScreenShareButton }
}
